<template>
    <b-container fluid class="mt-4 bg-footer">
        <b-row>
            <b-col class="text-center">
                <b-link href="https://www.twitch.tv/poyosi" target="_blank">
                  <font-awesome-icon :icon="['fab', 'twitch']" />
                </b-link>
                <b-link href="https://www.youtube.com/channel/UC1uACKT7nZ_hDAlfDKl7dFg" target="_blank">
                  <font-awesome-icon :icon="['fab', 'youtube']" />
                </b-link>
                <b-link href="https://twitter.com/KPoyox" target="_blank">
                  <font-awesome-icon :icon="['fab', 'twitter']" />
                </b-link>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center">
                <strong>&copy; {{ new Date().getFullYear() }} poyosi.net</strong>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { 
    BContainer,
    BRow,
    BCol,
} from 'bootstrap-vue'

import {
    library
} from '@fortawesome/fontawesome-svg-core'

import {
    fab
} from '@fortawesome/free-brands-svg-icons'

library.add(fab)

export default {
    components: {
        BContainer,
        BRow,
        BCol,
    }
}
</script>

<style scoped>
.container {
    padding-left: 0;
    padding-right: 0;
}
.container-fluid {
    padding-left: 0;
    padding-right: 0;
}
.bg-footer {
    background-color: #CCEBFF;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1000 1000'%3E%3Cdefs%3E%3CradialGradient id='a' cx='500' cy='500' r='40.3%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23CCEBFF'/%3E%3Cstop offset='1' stop-color='%2361A4FF'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='500' cy='500' r='80%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23BAD5FF' stop-opacity='1'/%3E%3Cstop offset='1' stop-color='%23BAD5FF' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='1000' height='1000'/%3E%3Cg fill='none' stroke='%234F6EFF' stroke-width='3' stroke-miterlimit='10' stroke-opacity='0.1'%3E%3Crect x='12.5' y='12.5' width='975' height='975'/%3E%3Crect x='25' y='25' width='950' height='950'/%3E%3Crect x='37.5' y='37.5' width='925' height='925'/%3E%3Crect x='50' y='50' width='900' height='900'/%3E%3Crect x='62.5' y='62.5' width='875' height='875'/%3E%3Crect x='75' y='75' width='850' height='850'/%3E%3Crect x='87.5' y='87.5' width='825' height='825'/%3E%3Crect x='100' y='100' width='800' height='800'/%3E%3Crect x='112.5' y='112.5' width='775' height='775'/%3E%3Crect x='125' y='125' width='750' height='750'/%3E%3Crect x='137.5' y='137.5' width='725' height='725'/%3E%3Crect x='150' y='150' width='700' height='700'/%3E%3Crect x='162.5' y='162.5' width='675' height='675'/%3E%3Crect x='175' y='175' width='650' height='650'/%3E%3Crect x='187.5' y='187.5' width='625' height='625'/%3E%3Crect x='200' y='200' width='600' height='600'/%3E%3Crect x='212.5' y='212.5' width='575' height='575'/%3E%3Crect x='225' y='225' width='550' height='550'/%3E%3Crect x='237.5' y='237.5' width='525' height='525'/%3E%3Crect x='250' y='250' width='500' height='500'/%3E%3Crect x='262.5' y='262.5' width='475' height='475'/%3E%3Crect x='275' y='275' width='450' height='450'/%3E%3Crect x='287.5' y='287.5' width='425' height='425'/%3E%3Crect x='300' y='300' width='400' height='400'/%3E%3Crect x='312.5' y='312.5' width='375' height='375'/%3E%3Crect x='325' y='325' width='350' height='350'/%3E%3Crect x='337.5' y='337.5' width='325' height='325'/%3E%3Crect x='350' y='350' width='300' height='300'/%3E%3Crect x='362.5' y='362.5' width='275' height='275'/%3E%3Crect x='375' y='375' width='250' height='250'/%3E%3Crect x='387.5' y='387.5' width='225' height='225'/%3E%3Crect x='400' y='400' width='200' height='200'/%3E%3Crect x='412.5' y='412.5' width='175' height='175'/%3E%3Crect x='425' y='425' width='150' height='150'/%3E%3Crect x='437.5' y='437.5' width='125' height='125'/%3E%3Crect x='450' y='450' width='100' height='100'/%3E%3Crect x='462.5' y='462.5' width='75' height='75'/%3E%3Crect x='475' y='475' width='50' height='50'/%3E%3Crect x='487.5' y='487.5' width='25' height='25'/%3E%3C/g%3E%3Crect fill-opacity='0.1' fill='url(%23b)' width='1000' height='1000'/%3E %3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
strong {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.svg-inline--fa {
    min-width: 20px;
    width: 1.2vw;
    height: auto;
    margin: 0 1vw;
}
.fa-twitch {
    color: #6441A4;
}
.fa-youtube {
    color: #FF0000;
}
.fa-twitter {
    color: #1DA1F2;
}
</style>
